<template>
  <div
    ref="element"
    class="style-bard"
    v-html="html"
  />
</template>

<script setup lang="ts">
const element = ref<HTMLDivElement>()

defineProps<{
  html?: string | null
  size?: 'regular'
}>()

useNuxtLinks(element)
</script>
